<form [formGroup]="form" (ngSubmit)="handleSubmit()" class="payment-search">
	<input class="payment-search__input" formControlName="name" />
	<i class="payment-search__icon tagmeicon tagmeicon-buscar" (click)="handleSubmit()"></i>
</form>
